var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"font-weight-light"},[_vm._v("fret"),_c('span',{staticClass:"font-weight-bold"},[_vm._v("share")])])}]

export { render, staticRenderFns }